import React, { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";

import Navbar from "../../Navbar";
import TopBar from "../../topbar";
import { BsPlusLg, BsTrash, BsPencilSquare, BsCheck2All } from "react-icons/bs";
import {
  Map,
  GoogleApiWrapper,
  Marker,
  InfoWindow,
  Circle,
} from "google-maps-react";
import { getData } from "../../../_helpers";

import PlacesAutocomplete from "react-places-autocomplete";
import {
  geocodeByAddress,
  geocodeByPlaceId,
  getLatLng,
} from "react-places-autocomplete";
import { getAddressByLatLng } from "../../../_helpers/GeoCoder";
import {
  AiOutlineInfoCircle,
  AiFillDelete,
  AiOutlinePlus,
  AiOutlineMinus,
} from "react-icons/ai";
import { FaCheckCircle } from "react-icons/fa";
import { BsPlusCircleFill } from "react-icons/bs";
import { nanoid } from "nanoid";
import $ from "jquery";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Footer from "../../../layout/footer";
import {
  amenityService,
  safetyFeatureService,
  propertyService,
  userService,
  bankService,
} from "../../../_services";
import constant from "../../../_config/constant";
import { processMediaUrl } from "../../../_helpers/utils";
import { SleepingArrangements } from "./SleepingArrangements";
import { Wrapper } from "./Wrapper";
import { BasicDetailsForm, validateBasicDetailsForm } from "./BasicDetailsForm";
import { Details, validateDetailsForm } from "./Details";
import { HouseRules, validateRules } from "./HouseRules";
import { AddPhotos, validatePhotos } from "./AddPhotos";
import { Amenities, validateAmenities } from "./Amenities";
import { SafetyFeatures, validateSafety } from "./SafetyFeatures";
import { PricingAndFee, validatePricingAndFee } from "./PricingAndFee";
import { Terms, validateTermsForm } from "./Terms";
import { SecurityCheckPoints } from "./SecurityCheckPoints";
import { PayoutMethod } from "./PayoutMethod";
var Modal = require("react-bootstrap-modal");
import CustomModal from "./../../../components/ReactModal";
import { PendingSuccessModal } from "../components/PendingSuccessModal";
import { propertyBookedCount } from "../../../_helpers/helpers";
import { validateSleepingArrangements } from "../validators/validateSleepingArrangements";
import { SubscriptionPlans } from "./SubscriptionPlans";
import { UploadingView } from "../components/UploadingView";

function EditProperty(props) {
  //window.scrollTo({ top: 0, behavior: "smooth" });
  const [formStep, setFormStep] = useState(0);
  
  const [formData, setFormData] = useState({});
  const [amenityList, setAmenityList] = useState([]);
  const [apiCalled, setApiCalled] = useState(false);
  const [hostDetail, setDetail] = useState({});
  const [isPaymentConfirm, setIspaymentConfirm] = useState(hostDetail.payoutVerification);
  const [isButtonDisable, setIsButtonDisable] = useState(hostDetail.payoutVerification);

  const [bookedCount, setBookedCount] = useState({hotbedCount: 0, coldbedCount: 0})

  const [safetyFeatureList, setSafetyFeatureList] = useState([]);
  const [requesting, setRequest] = useState(false);
  const [updating, setUpdating] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const params = useParams();


  const [validateErrorStep, setValidateErrorStep] = useState(null)
  
  const handleNextStep = (step) => {
    // if (step < 10) {
    //   setFormStep((step) => step + 1);
    // }
    if(hostDetail.payoutVerification == 1 )
    {
      console.log("step--11---", step);
      if (step < 10) {
        setFormStep((step) => step + 1);
      }
    }
    else
    {
      console.log("step--0---", step);
      if (step < 11) {
        setFormStep((step) => step + 1);
      }
    }
  };

  const handlePrevStep = (step) => {
    if (step > 0) {
      setFormStep((step) => step - 1);
    }
  };


  const validateFormData = (data) => {
    setValidateErrorStep(null)
    const validators = [
      {step: 1, validator:validateBasicDetailsForm},
      {step: 2, validator:validateDetailsForm},
      {step: 3, validator:validateRules},
      {step: 4, validator:validatePhotos},
      {step: 5, validator:validateAmenities},
      {step: 6, validator:validateSafety},
      {step: 7, validator:validateSleepingArrangements},
      {step: 8, validator:validatePricingAndFee},
      {step: 9, validator:validateTermsForm}
    ]

    const dataForValidate = {...formData, ...data}
    const validateResults = validators.map((validator) => {
      return {step: validator.step, result: validator.validator(dataForValidate) }
    })

    const error = validateResults.find((result) => {
      return !result.result.isValid
    })

    if(error) {
      const message = error.result.errors.length > 0 ? error.result.errors[0].error : ""
      toast.error(`Error on step ${error.step}. ${message}`);
      setValidateErrorStep(error.step)
      return false
    }


    return true
  }

  const save = (data) => {
    //alert(formStep);
    const isLastStep = (hostDetail.payoutVerification && formStep >= 10) || formStep >= 11
    
    setUpdating(true);
    var reqData = Object.assign({}, validateErrorStep ? {...formData, ...data, location: Array.isArray(formData.location) ? formData.location :  Object.values(formData.location)} : data);
    reqData["propertyId"] = params.id;
    
    if(validateErrorStep) {
      reqData["fullUpdate"] = true;
    } else {
      reqData["step"] = formStep;
    }
    if (reqData.step == 0 && data.location) {
      reqData.location = Object.values(data.location);
    }
    setFormData({...formData, ...data})
    if(!validateFormData(data)) {
      setUpdating(false);
      return
    }
    propertyService._update(reqData).then(
      (objS) => {
        if (objS.status) {
          toast.success("Details updated.");
          if(isLastStep) {
            setShowSuccessModal(true)
           
          }
        } else {
          toast.error("Something went wrong.");
        }
        setUpdating(false);
      },
      (error) => {
        setUpdating(false);
      }
    );
  };

  const savePhoto = (data) => {
    const onComplete = data.onComplete
    const setProgressText = data.setProgressText ??((value) => {})
    setUpdating(true);
    delete data.onComplete
    delete data.setProgressText
    data["propertyId"] = params.id;
    const needFormUpdate = validateErrorStep != null
    if(!validateFormData(data)) {
      setUpdating(false);
      return
    }
    setProgressText("0%")
    propertyService.updatePhoto(data, ({batchNumber, totalBatches, itemsProcessed, totalItems, progress}) => {
      setProgressText(`${Math.round(progress)}%`)
    }).then(
      (objS) => {
        if (objS.status) {
          if(objS.data && objS.data.images) {
            let newFormData = {...formData, images: objS.data.images, photos: undefined}
            delete newFormData.photos
            setFormData(newFormData)
          }
          if(needFormUpdate) {
            var reqData = Object.assign({}, {...formData, location: Array.isArray(formData.location) ? formData.location :  Object.values(formData.location)});
            reqData["propertyId"] = params.id;
            reqData["fullUpdate"] = true;
            if (reqData.step == 0 && data.location) {
              reqData.location = Object.values(data.location);
            }
            propertyService._update(reqData).then(
              (objS) => {
                if (objS.status) {
                  toast.success("Details updated.");
                  if(onComplete) {
                    onComplete()
                  }
                } else {
                  toast.error("Something went wrong.");
                }
                setProgressText("")
                setUpdating(false);
              },
              (error) => {
                setProgressText("")
                setUpdating(false);
              }
            );
          } else {
            toast.success("Details updated.");
            if(onComplete) {
              onComplete()
            }
            setProgressText("")
            setUpdating(false);
          }
        } else {
          toast.error("Something went wrong.");
          setProgressText("")
          setUpdating(false);
        }
       
      },
      (error) => {
        setProgressText("")
        setUpdating(false);
      }
    );
  };

  const handleFormSubmission = () => {
    alert("jk");
    setRequest(true);
    formData.propertyId = params.id;
    propertyService.update(formData).then(
      (objS) => {
        props.history.push("/properties");
      },
      (error) => {}
    );
  };
  useEffect(() => {
    window.addEventListener("popstate", (event) => {
      event.preventDefault();
      document.body.classList.remove("modal-open");
      window.$("#addRoomModal").modal("hide");
      window.$(".modal-backdrop").remove();
    });
  }, []);

  useEffect(() => {
    const prefetch = () => {
      amenityService.List({}).then(
        (objS) => {
          if (objS.status) setAmenityList(objS.data);
        },
        (error) => {}
      );
      safetyFeatureService.List({}).then(
        (objS) => {
          if (objS.status) setSafetyFeatureList(objS.data);
        },
        (error) => {}
      );

      userService.getDetail({}).then(
        (objS) => {
          if (objS.status) {
            setDetail(objS.data);
          }
        },
        (error) => {}
      );

      propertyService.getDetail(params.id).then(
        (objS) => {
          if (objS.status) {
            objS.data.location =
              objS.data.location &&
              objS.data.location[0] &&
              objS.data.location[1]
                ? { lat: objS.data.location[1], lng: objS.data.location[0] }
                : { lat: constant.lat, lng: constant.lng };
            setFormData({ ...objS.data });
            setBookedCount(propertyBookedCount(objS.data))
          }
          setApiCalled(true);
        },
        (error) => {
          setApiCalled(true);
        }
      );
    };

    prefetch();
  }, []);
  console.log("hostDetailPayout - index " +hostDetail.payoutVerification  );
  localStorage.setItem("hostDetailPayout", hostDetail.payoutVerification);
  const handleFormStep = (i) => {
    setFormStep(i);
  };

  return (
    <Wrapper>
      <ToastContainer />
      {apiCalled && (
        <div className="row">
          {/* <form onSubmit={handleFormSubmission} enctype="multipart/form-data"> */}
          {formData.status != "Pending" ? (
            <div className="tw-py-4 tw-flex tw-flex-nowrap tw-overflow-x-auto">
              <span
                onClick={() => handleFormStep(0)}
                className={`tw-flex-shrink-0 tw-rounded-l-md tw-p-4 tw-text-sm tw-border-b-2 tw-cursor-pointer tw-border-gray-400  tw-block ${
                  formStep === 0
                    ? "tw-bg-[#23426e] tw-text-white "
                    : "tw-bg-gray-100"
                }`}
              >
                Basics
              </span>
              <span
                onClick={() => handleFormStep(1)}
                className={`tw-p-4 tw-text-sm tw-border-b-2 tw-flex-shrink-0  tw-cursor-pointer tw-border-gray-400  tw-block ${
                  formStep === 1
                    ? "tw-bg-[#23426e] tw-text-white "
                    : "tw-bg-gray-100"
                }`}
              >
                Details
              </span>
              <span
                onClick={() => handleFormStep(2)}
                className={`tw-p-4 tw-text-sm tw-border-b-2 tw-flex-shrink-0  tw-cursor-pointer tw-border-gray-400  tw-block ${
                  formStep === 2
                    ? "tw-bg-[#23426e] tw-text-white "
                    : "tw-bg-gray-100"
                }`}
              >
                House Rules
              </span>
              <span
                onClick={() => handleFormStep(3)}
                className={`tw-p-4 tw-text-sm tw-border-b-2 tw-flex-shrink-0  tw-cursor-pointer tw-border-gray-400  tw-block ${
                  formStep === 3
                    ? "tw-bg-[#23426e] tw-text-white "
                    : "tw-bg-gray-100"
                }`}
              >
                Photos
              </span>
              <span
                onClick={() => handleFormStep(4)}
                className={`tw-p-4 tw-text-sm tw-border-b-2 tw-flex-shrink-0  tw-cursor-pointer tw-border-gray-400  tw-block ${
                  formStep === 4
                    ? "tw-bg-[#23426e] tw-text-white "
                    : "tw-bg-gray-100"
                }`}
              >
                Amenities
              </span>
              <span
                onClick={() => handleFormStep(5)}
                className={`tw-p-4 tw-text-sm tw-border-b-2 tw-flex-shrink-0  tw-cursor-pointer tw-border-gray-400  tw-block ${
                  formStep === 5
                    ? "tw-bg-[#23426e] tw-text-white "
                    : "tw-bg-gray-100"
                }`}
              >
                Safety Features
              </span>
              <span
                onClick={() => handleFormStep(6)}
                className={`tw-p-4 tw-text-sm tw-border-b-2 tw-flex-shrink-0  tw-cursor-pointer tw-border-gray-400  tw-block ${
                  formStep === 6
                    ? "tw-bg-[#23426e] tw-text-white "
                    : "tw-bg-gray-100"
                }`}
              >
                Sleeping Arrangements
              </span>
              <span
                onClick={() => handleFormStep(7)}
                className={`tw-p-4 tw-text-sm tw-border-b-2 tw-flex-shrink-0  tw-cursor-pointer tw-border-gray-400  tw-block ${
                  formStep === 7
                    ? "tw-bg-[#23426e] tw-text-white "
                    : "tw-bg-gray-100"
                }`}
              >
                Pricing and Fees
              </span>
              <span
                onClick={() => handleFormStep(8)}
                className={`tw-p-4 tw-text-sm tw-border-b-2 tw-flex-shrink-0  tw-cursor-pointer tw-border-gray-400  tw-block ${
                  formStep === 8
                    ? "tw-bg-[#23426e] tw-text-white "
                    : "tw-bg-gray-100"
                }`}
              >
                Terms
              </span>
              <span
                onClick={() => handleFormStep(9)}
                className={`tw-p-4 tw-text-sm tw-border-b-2 tw-flex-shrink-0  tw-cursor-pointer tw-border-gray-400  tw-block ${
                  formStep === 9
                    ? "tw-bg-[#23426e] tw-text-white "
                    : "tw-bg-gray-100"
                }`}
              >
                Subscription Plans
              </span>
              {hostDetail.payoutVerification == 1 
              ?
              <span
                onClick={() => handleFormStep(10)}
                className={`tw-flex-shrink-0  tw-rounded-r-md  tw-p-4 tw-text-sm tw-border-b-2 tw-cursor-pointer tw-border-gray-400  tw-block ${
                  formStep === 10
                    ? "tw-bg-[#23426e] tw-text-white "
                    : "tw-bg-gray-100"
                }`}
              >
                Security Checkpoint
              </span>
              :
                <>
                <span
                onClick={() => handleFormStep(10)}
                className={`tw-flex-shrink-0  tw-rounded-r-md  tw-p-4 tw-text-sm tw-border-b-2 tw-cursor-pointer tw-border-gray-400  tw-block ${
                  formStep === 10
                    ? "tw-bg-[#23426e] tw-text-white "
                    : "tw-bg-gray-100"
                }`}
              >
                Payout Method
              </span>
              <span
                    onClick={() => handleFormStep(11)}
                    className={`tw-flex-shrink-0  tw-rounded-r-md  tw-p-4 tw-text-sm tw-border-b-2 tw-cursor-pointer tw-border-gray-400  tw-block ${
                      formStep === 11
                        ? "tw-bg-[#23426e] tw-text-white "
                        : "tw-bg-gray-100"
                    }`}
                  >
                    Security Checkpoint
                  </span>
           </>
              
              }
              {/* <span
                onClick={() => handleFormStep(9)}
                className={`tw-flex-shrink-0  tw-rounded-r-md  tw-p-4 tw-text-sm tw-border-b-2 tw-cursor-pointer tw-border-gray-400  tw-block ${
                  formStep === 9
                    ? "tw-bg-[#23426e] tw-text-white "
                    : "tw-bg-gray-100"
                }`}
              >
                Payout Method
              </span> */}
              
            </div>
          ) : (
            <div></div>
          )}
          <BasicDetailsForm
            className={`${formStep === 0 ? "tw-block" : "tw-hidden"}`}
            onNext={() => handleNextStep(formStep)}
            onPrev={() => handlePrevStep(formStep)}
            formData={formData}
            setFormData={setFormData}
            save={save}
            updating={updating}
            bookedCount={bookedCount}
          />
          <Details
            className={`${formStep === 1 ? "tw-block" : "tw-hidden"}`}
            formData={formData}
            setFormData={setFormData}
            onNext={() => handleNextStep(formStep)}
            onPrev={() => handlePrevStep(formStep)}
            save={save}
            updating={updating}
          />
          <HouseRules
            onNext={() => handleNextStep(formStep)}
            onPrev={() => handlePrevStep(formStep)}
            formData={formData}
            setFormData={setFormData}
            className={`${formStep === 2 ? "tw-block" : "tw-hidden"}`}
            save={save}
            updating={updating}
          />
          <AddPhotos
            onNext={() => handleNextStep(formStep)}
            onPrev={() => handlePrevStep(formStep)}
            formData={formData}
            setFormData={setFormData}
            className={`${formStep === 3 ? "tw-block" : "tw-hidden"}`}
            savePhoto={savePhoto}
            updating={updating}
          />

          <Amenities
            className={`${formStep === 4 ? "tw-block" : "tw-hidden"}`}
            formData={formData}
            amenityList={amenityList}
            setFormData={setFormData}
            onNext={() => handleNextStep(formStep)}
            onPrev={() => handlePrevStep(formStep)}
            save={save}
            updating={updating}
          />
          <SafetyFeatures
            className={`${formStep === 5 ? "tw-block" : "tw-hidden"}`}
            formData={formData}
            safetyFeatureList={safetyFeatureList}
            setFormData={setFormData}
            onNext={() => handleNextStep(formStep)}
            onPrev={() => handlePrevStep(formStep)}
            save={save}
            updating={updating}
          />
          <SleepingArrangements
            formData={formData}
            className={`${formStep === 6 ? "tw-block" : "tw-hidden"}`}
            setFormData={setFormData}
            onNext={() => handleNextStep(formStep)}
            onPrev={() => handlePrevStep(formStep)}
            save={save}
            updating={updating}
          />
          <PricingAndFee
            className={`${formStep === 7 ? "tw-block" : "tw-hidden"}`}
            formData={formData}
            setFormData={setFormData}
            onNext={() => handleNextStep(formStep)}
            onPrev={() => handlePrevStep(formStep)}
            save={save}
            updating={updating}
          />
          <Terms
            className={`${formStep === 8 ? "tw-block" : "tw-hidden"}`}
            formData={formData}
            setFormData={setFormData}
            onNext={() => handleNextStep(formStep)}
            onPrev={() => handlePrevStep(formStep)}
            save={save}
            updating={updating}
          />
          <SubscriptionPlans
           className={`${formStep === 9 ? "tw-block" : "tw-hidden"}`}
           formData={formData}
           setFormData={setFormData}
           onNext={() => handleNextStep(formStep)}
           onPrev={() => handlePrevStep(formStep)}
           save={save}
           updating={updating}
          />

          {
              hostDetail.payoutVerification == 1 
              ? 
              <SecurityCheckPoints
            className={`${formStep === 10 ? "tw-block" : "tw-hidden"}`}
            formData={formData}
            setFormData={setFormData}
            requesting={requesting}
            onNext={() => handleFormSubmission()}
            onPrev={() => handlePrevStep(formStep)}
            save={save}
            updating={updating}
            
            hostDetail={hostDetail}
            isPaymentConfirm={isPaymentConfirm}
            />
              : 
  
              <PayoutMethod
            className={`${formStep === 10 ? "tw-block" : "tw-hidden"}`}
            formData={formData}
            setFormData={setFormData}
            onNext={() => handleNextStep(formStep)}
            onPrev={() => handlePrevStep(formStep)}
            //save={save}
            updating={updating}
            hostDetail={hostDetail}
            setIspaymentConfirm={setIspaymentConfirm}
            isPaymentConfirm={isPaymentConfirm}
            setIsButtonDisable={setIsButtonDisable}
            isButtonDisable={isButtonDisable}
          />
  
          }
          {
            hostDetail.payoutVerification == 0
            ? 
            <SecurityCheckPoints
            className={`${formStep === 11 ? "tw-block" : "tw-hidden"}`}
            formData={formData}
            setFormData={setFormData}
            requesting={requesting}
            onNext={() => handleFormSubmission()}
            onPrev={() => handlePrevStep(formStep)}
            save={save}
            updating={updating}
            hostDetail={hostDetail}
            isPaymentConfirm={isPaymentConfirm}
          />
            :
            <></>

          }
  
          {/* <PayoutMethod
            className={`${formStep === 9 ? "tw-block" : "tw-hidden"}`}
            formData={formData}
            setFormData={setFormData}
            onNext={() => handleNextStep(formStep)}
            onPrev={() => handlePrevStep(formStep)}
            //save={save}
            updating={updating}
            hostDetail={hostDetail}
          />
          <SecurityCheckPoints
            className={`${formStep === 10 ? "tw-block" : "tw-hidden"}`}
            formData={formData}
            setFormData={setFormData}
            requesting={requesting}
            onNext={() => handleFormSubmission()}
            onPrev={() => handlePrevStep(formStep)}
            save={save}
            updating={updating}
            hostDetail={hostDetail}
          /> */}
          {showSuccessModal && (
            <PendingSuccessModal props={props}/>
          )}
        </div>
      )}
    </Wrapper>
  );
}

export default EditProperty;
